import { render, staticRenderFns } from "./NowLoading.vue?vue&type=template&id=52df4cc1&scoped=true&"
import script from "./NowLoading.vue?vue&type=script&lang=js&"
export * from "./NowLoading.vue?vue&type=script&lang=js&"
import style0 from "./NowLoading.vue?vue&type=style&index=0&id=52df4cc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df4cc1",
  null
  
)

export default component.exports